import { Injectable, Inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { SecurityHelperService } from '../security/services/security-helper.service';

@Injectable()
export class ServicesHelperService {
  constructor(@Inject('BASE_URL') private baseUrl: string, private securityHelperService: SecurityHelperService) {}

  public getHeaders(): HttpHeaders {
    let siteUrl = this.baseUrl.slice(0, -1);
    let token = this.securityHelperService.token;

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', siteUrl);
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers = headers.append('Accept', 'application/json');
    return headers;
  }

  public getPDFHeaders(): HttpHeaders {
    let siteUrl = this.baseUrl.slice(0, -1);
    let token = this.securityHelperService.token;

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', siteUrl);
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers = headers.append('Accept', 'application/pdf');
    return headers;
  }

  public getImageHeaders(): HttpHeaders {
    let siteUrl = this.baseUrl.slice(0, -1);

    let token = this.securityHelperService.token;

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', siteUrl);
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'Bearer ' + token);
    return headers;
  }

  public getRequestOptionsFormData(): HttpHeaders {
    let siteUrl = this.baseUrl.slice(0, -1);

    let token = this.securityHelperService.token;

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', siteUrl);
    headers = headers.append('enctype', 'multipart/form-data');
    headers = headers.append('Authorization', 'Bearer ' + token);
    return headers;
  }

  public getHeadersSIAT(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'text/plain');
    return headers;
  }
  public getHeadersBanxico(): HttpHeaders {
    let siteUrl = this.baseUrl.slice(0, -1);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', siteUrl);
    headers = headers.append('Accept', 'text/plain');
    headers = headers.append('Bmx-Token', '288af6e3b78b9f5ddace42c6ab98fd156c3fe5957f134c9d46203596e220ebad');
    return headers;
  }
  public getHeadersBlob(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', '*/*');
    return headers;
  }
}
